export default "__VITE_ASSET__CjCtEjYT__"